import VehicleRegistrationLookupsHtml from './vehicle-registration.lookups.html';

export function VehicleRegistrationLookupsDirective () : ng.IDirective {
  const directive : ng.IDirective = {
    controller: 'VehicleRegistrationLookupsCtrl',
    restrict  : 'E',
    scope     : {
      lookups: '='
    },
    templateUrl: VehicleRegistrationLookupsHtml
  };

  return directive;
};
